import {
    userService
} from '../_services';
import {
    router
} from '../_helpers';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user ?
    {
        status: {
            loggedIn: true
        },
        user
    } :
    {
        status: {},
        user: null
    };

export const authentication = {
    namespaced: true,
    state: initialState,
    actions: {
        login({
            dispatch,
            commit
        }, {
            username,
            password
        }) {
            commit('loginRequest', {
                username
            });

            userService.login(username, password)
                .then(
                    user => {
                        commit('loginSuccess', user);
                        router.push('/');
                    },
                    error => {
                        commit('loginFailure', error);
                        dispatch('alert/error', error, {
                            root: true
                        });
                    }
                );
        },
        register({
            dispatch,
            commit
        }, {
            username,
            password,
            firstname,
            lastname
        }) {


            userService.register(username, password, firstname, lastname)
                .then(
                    user => {
                        commit('registerSuccess', user);
                        router.push('/login');
                    },
                    error => {
                        commit('registerFailure', error);
                        dispatch('alert/error', error, {
                            root: true
                        });
                    }
                );
        },
        logout({
            commit
        }) {
            commit('logout');
            userService.logout();

            router.push('/login');
        }
    },

    mutations: {
        loginRequest(state, user) {
            state.status = {
                loggingIn: true
            };
            state.user = user;
        },
        loginSuccess(state, user) {
            state.status = {
                loggedIn: true
            };
            state.user = user;
        },
        loginFailure(state) {
            state.status = {};
            state.user = null;
        },
        logout(state) {
            state.status = {};
            state.user = null;
        },
        registerSuccess(state) {
            state.status = {};
            state.user = null;
        },
        registerFailure(state) {
            state.status = {};
            state.user = null;
        }
    }
}